import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import toast from 'react-hot-toast';
import { MixpanelEvent } from '@/services/eventEnums';
import { MixpanelTracking } from '@/services/mixpanel';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

const customToasterUpdater = (
  message: string,
  id: string | null,
  variant?: string | null,
  event?: { name: MixpanelEvent; properties?: {} } | false
) => {
  let color = variant === 'success' ? '#2e7d32' : variant === 'info' ? '#496178' : '#D0342C';

  if (event) {
    MixpanelTracking.getInstance().track(event.name, event.properties);
  }

  return toast(
    t => (
      <Box className="error-alert">
        <Stack direction={'row'} spacing={1} alignItems="center">
          {variant === 'info' ? (
            <InfoOutlinedIcon sx={{ fontSize: '20px !important' }} />
          ) : variant === 'success' ? (
            <CheckCircleOutlineOutlinedIcon sx={{ fontSize: '20px !important' }} />
          ) : (
            <ErrorOutlineOutlinedIcon sx={{ fontSize: '20px !important' }} />
          )}
          <Typography variant="body2">{message}</Typography>
        </Stack>
        <IconButton name="Close Notification" onClick={() => toast.dismiss(t.id)}>
          <CloseIcon />
        </IconButton>
      </Box>
    ),
    { ...(id && { id }), style: { background: `${color}`, padding: '0px', borderRadius: '8px' } }
  );
};

export default customToasterUpdater;
